export enum WhatsAppMediaStatus {
  Pending = 'pending',
  Stored = 'stored',
  Failed = 'failed',
}
